import { render, staticRenderFns } from "./vReportsRow.vue?vue&type=template&id=52892bf7&scoped=true&"
import script from "./vReportsRow.vue?vue&type=script&lang=js&"
export * from "./vReportsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52892bf7",
  null
  
)

export default component.exports